<template>
  <validation-provider :name="label" :rules="rule" v-slot="validationContext">
    <div
      class="preview-holder"
      :class="{ invalid: getValidationState(validationContext) === false }"
      @mouseenter="showUploadButton = true"
      @mouseleave="showUploadButton = false"
    >
    
    <Transition>
        
      <div class="remove-logo d-flex justify-content-center align-items-center"
        v-if="isShown && isDeleteButtonShow && (logo.base64 || (imagePath != null && !imagePath.includes('/img/img-placeholder')))"
        @click="removeLogo">
        <i class="bx bx-trash-alt"></i>
      </div>
    </Transition>
    <div class="upload-container">
      <!-- Image -->
      <div class="position-relative">
        <div v-bind:style="background" class="logo-container"></div>
        <!-- Buttons and Interactions -->
        <transition name="fade">
          <div
            v-if="(!logo.base64 && (imagePath == null || ( imagePath != null && imagePath.includes('/img/img-placeholder')))) || showUploadButton"
            class="d-flex w-100 h-100 flex-column justify-content-center align-items-center animated-container position-absolute">
            <div>
              <img
                class="align-self-center mb-2"
                src="@/assets/images/upload.png"
                alt=""
                height="29"
                width="24"
              />
            </div>
            <div class="mb-3" :style="{ color: '#000' }">
              {{ uploadText }}
            </div>
            <b-btn size="sm" variant="primary" class="btn-upload w-50">Upload</b-btn>
          </div>
        </transition>
      </div>
      <template v-if="shouldValidate">
        <b-form-file
          class="file-uploader"
          type="file"
          v-model="file"
          @click.native="fileClick"
          @blur.native="fileBlur"
          @change="onFileChange"
          plain
        />
        <b-form-invalid-feedback>
          {{ validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </template>

      <template v-if="!shouldValidate">
        <b-form-file
          class="file-uploader"
          type="file"
          v-model="file"
          @click.native="fileClick"
          @blur.native="fileBlur"
          @change="onFileChange"
          plain
        />
      </template>
    </div>
  </div>
    <div v-if="isRequired && getValidationState(validationContext) === false" class="validation-error">
      Image is required.
    </div>
    <div v-if="errorMsgFileExtension.length > 0" class="validation-error">
      {{ errorMsgFileExtension }}
    </div>
  </validation-provider>
</template>

<script>
import shortid from "shortid";
import _ from "lodash";

export default {
  name: "image-uploader",
  data() {
    return {
      dialogActive: false,
      isShown: true,
      file: null,
      imagePath: null,
      logoPreview: null,
      logo: {
        filename: this.value ? this.value.filename : null,
        type: this.value ? this.value.type : null,
        base64: this.value ? this.value.base64 : null,
      },
      errorMsgFileExtension: "",
      isDeleteButtonShow: true,
      imageLoaded: false,
      showUploadButton: false,
    };
  },
  computed: {
    background: {
      get() {
        var backgroundImage = null;

        if (this.imagePath) {
          backgroundImage = this.imagePath;
        }

        // this will fix upn loading the svg rendering instead of white.
        let extensionType = this.logo.type == 'svg' ? 'svg+xml' : this.logo.type;

        // load the background image.
        if (this.logo.base64) {
          backgroundImage = `data:image/${extensionType};base64,${this.logo.base64.toString("base64")}`;
        }

        var backgroundStyle = {
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "center center",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          opacity: this.showUploadButton ? 0.2 : 1,
        };

        if (backgroundImage) {
          // Check if it's an SVG image by examining its file extension
          backgroundStyle.backgroundImage = `url("${backgroundImage}")`;
        }

        return backgroundStyle;
      },
    },

    rule: {
      get() {
        if (this.shouldValidate) {
          return this.isRequired ? "required" : "";
        } else {
          return "";
        }
      },
    },
    shouldValidate: {
      get() {
        return (
          this.isRequired && (this.imagePath == null || this.imagePath == "")
        );
      },
    },
  },
  props: [
    "label",
    "isRequired",
    "imageSrc",
    "value",
    "showDeleteButton",
    "uploadText",
  ],
  watch: {
    imageSrc(newVal) {
      this.logoPreview = null;
      this.imagePath = newVal;
    },
  },
  methods: {

    fileClick(e) {
      e.target.focus(); // Fix for safari not triggering blur.
      if (!this.dialogActive) {
        this.dialogActive = true;
      } else {
        e.preventDefault();
      }
    },
    fileBlur() {
      var _this = this;
      setTimeout(() => {
        _this.dialogActive = false;
      }, 2000);
    },
    onFileChange(e) {
      const reader = new FileReader();
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.logoPreview = null;
        this.$emit("input", {
          filename: null,
          type: null,
          base64: null,
        });
        return;
      }

      const allowedExtensions = ["jpg", "jpeg", "png", "svg"];
      const selectedFile = files[0];
      console.log("selectedFile: ", selectedFile);
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.errorMsgFileExtension = 'Invalid image upload! Only [.jpg, .jpeg, .png .svg] are accepted.';
        console.log("Invalid file extension. Please select a valid image file.");
        return;
      }
      this.errorMsgFileExtension = "";

      this.logoPreview = URL.createObjectURL(selectedFile);

      reader.onloadend = () => {
        const base64Data = reader.result;
        this.logo.base64 = new Buffer.from(
          base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ""),
          "base64"
        );
        this.logo.type = fileExtension;
        if (this.logo.type === "svg+xml") {
          this.logo.type = "svg";
        }
        this.imageLoaded = true;
        this.logo.filename = `${shortid.generate()}.${this.logo.type}`;
        this.$emit("input", _.cloneDeep(this.logo));
      };
      reader.readAsDataURL(selectedFile);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    removeLogo() {

      this.logo = {
        filename: null,
        type: null,
        base64: null,
      };

      this.$emit("input", {
        filename: null,
        type: null,
        base64: null,
      });
      
      this.$emit("trigger-method");
      if(this.imagePath != null && !this.imagePath.includes('/img/img-placeholder'))
      {
        this.file = null;
        this.imagePath = null;
        this.logoPreview = null;
      }
      
    },
  },
  mounted() {
    this.imagePath = this.imageSrc;
    this.isDeleteButtonShow = this.showDeleteButton ?? true;
  },
};
</script>

<style scoped>
.item-logo {
  max-width: 200px;
  max-height: 239px;
}

.preview-holder {
  width: 100%;
  height: 165px;
}

.preview-holder.invalid {
  border: solid 1px #ff0000;
}

.file-uploader {
  width: 100%;
  height: 100%;
  font-size: 20px;
  position: absolute;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
}

.remove-logo {
  z-index: 999999;
  cursor: pointer;
  border-radius: 50%;
  background: #fff;
  width: 30px;
  height: 30px;
  position: absolute;
  right: 20px;
  top: 40px;
  color: #e73092;
  transition: opacity 3s;
}

.remove-logo.shown {
  opacity: 1;
}

.remove-logo:hover {
  background: #f84b04;
  color: #fff;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.logo-container {
  width: 100%;
  border-radius: 8px;
  height: 163px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  transition: opacity 0.3s ease;
}

.validation-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 87.5%;
  color: #f34e4e;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.upload-container {
  border-radius: 8px;
  border: dashed 2px #f84b04;
  position: relative; /* Make sure it's a positioned container */
}

/* Use position-absolute to position the transitioned content */
.animated-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>